import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

const featherIcon = require('feather-icons');

const ToggleContainer = styled.label`
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
`;

const ToggleSwitch = styled.i`
  transition: background-color 0.2 ease-out;
  display: inline-block;
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
  }

  &:active {
    opacity: 0.7;
  }
`;

const ToggleInput = styled.input`
  display: none;
  &:checked + i {
    filter: invert(47%) sepia(42%) saturate(4734%) hue-rotate(309deg)
      brightness(101%) contrast(101%);
  }
  &:disabled + i {
    opacity: 0.7;
    cursor: not-allowed;
    &:after {
      opacity: 0.7;
    }
  }
`;

const ToggleIcon = ({
  name,
  size,
  strokeWidth,
  rotate,
  color,
  on,
  disabled,
  onChange,
  ...props
}) => {
  const handleChange = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    await onChange(e);
  };

  const shapeStyle = {
    width: size,
    height: size,
    transform: rotate ? `rotate(${rotate}deg)` : undefined,
  };

  const iconStyle = {
    strokeWidth,
    stroke: color,
    width: size,
    height: size,
    color,
  };

  const icon = featherIcon.icons[name];
  const svg = icon ? icon.toSvg(iconStyle) : '';
  const base64 = Buffer.from(svg, 'utf8').toString('base64');

  return (
    <ToggleContainer {...props} onClick={handleChange}>
      <ToggleInput
        type="checkbox"
        name={name}
        checked={on}
        disabled={disabled}
        onChange={() => {}}
      />
      <ToggleSwitch {...props} style={{ ...props.style, ...shapeStyle }}>
        <img src={`data:image/svg+xml;base64,${base64}`} alt={name} />
      </ToggleSwitch>
    </ToggleContainer>
  );
};

ToggleIcon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  rotate: PropTypes.number,
  color: PropTypes.string,
  on: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  style: PropTypes.object,
};

ToggleIcon.defaultProps = {
  name: 'bookmark',
  size: theme.iconSizes.s,
  strokeWidth: 2,
  rotate: 0,
  color: theme.colors.gray500,
  on: false,
  disabled: false,
  onChange: () => {},
  style: {},
};
export default ToggleIcon;
